// The assistant answers in the help's markup: {element-id|label} highlights an element in the app,
// [[tour-id:step|title]] opens a help step, **text** is bold and `text` is code.
const TOKEN = /\{([^|{}]+)\|([^|{}]+)(?:\|[^{}]*)?\}|\[\[([\w-]+):(\d+)\|([^\]]+)\]\]|\*\*([^*]+)\*\*|`([^`]+)`/g;

export function parseAnswer(text) {
  const re = new RegExp(TOKEN.source, 'g');
  const parts = [];
  let last = 0;
  let m;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push({ type: 'text', text: text.slice(last, m.index) });
    if (m[1] !== undefined) parts.push({ type: 'ref', helpId: m[1].trim(), text: m[2].trim() });
    else if (m[3] !== undefined) parts.push({ type: 'step', tourId: m[3], step: Number(m[4]), text: m[5].trim() });
    else if (m[6] !== undefined) parts.push({ type: 'bold', text: m[6] });
    else parts.push({ type: 'code', text: m[7] });
    last = re.lastIndex;
  }
  if (last < text.length) parts.push({ type: 'text', text: text.slice(last) });
  return parts;
}
